import classNames from 'classnames'
import Image from 'next/image'
import useTranslation from '../../../modules/i18n/useTranslation'
import { buildSanityImage } from '../../../modules/utils'
import Skeleton from '../../skeleton'
import { getApplicationStatus, getStatusBadge } from './EventDetailBody'

interface EventCardType {
  title: string
  thumbnail
  tagLists
  eventType: string
  dueDate: string
  startDate: string
  isOnGoing: boolean
  onClickCard?: () => void
  onClickTag?: (tag) => void
  isDetailPage?: boolean
}

const EventCard: React.FC<EventCardType> = ({
  title,
  thumbnail,
  tagLists,
  eventType,
  dueDate,
  startDate,
  isDetailPage = false,
  isOnGoing = false,
  onClickCard,
  onClickTag,
}) => {
  const { t } = useTranslation()
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

  return (
    <div onClick={() => onClickCard && onClickCard()}>
      <div className={style.cardWrapper(isDetailPage)}>
        <div>
          <div className="max-h-[60vh] max-w-[100vw]">
            <Image
              alt={thumbnail.alt}
              loading="lazy"
              className={classNames(!isDetailPage && 'rounded-[12px]', 'mx-auto aspect-[1.7083/1] object-cover')}
              src={buildSanityImage(thumbnail).url()}
              style={{
                width: '100%',
                height: '100%',
              }}
              width={336}
              height={196}
              quality={100}
            />
          </div>
        </div>
        <div className={style.descriptionSectionWrapper(isDetailPage)}>
          <div className={style.descriptionSection}>
            <div className={style.descriptionCategoryWrapper}>
              <div className="">{getStatusBadge(t, eventType)}</div>
              <div className="">{getApplicationStatus(t, dueDate)}</div>
              {tagLists?.map((tagItem, i) => (
                <button className={style.desciprtionTags} key={i} onClick={() => onClickTag && onClickTag(tagItem)}>
                  {tagItem}
                </button>
              ))}
            </div>
            <div className="flex flex-col">
              <div className={style.desciprtionTitle}>{title}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const style = {
  cardWrapper: (isDetailPage) =>
    isDetailPage
      ? ` relative min-w-[300px] cursor-pointer overflow-hidden rounded-[8px] border-gray-200 bg-white`
      : ` relative min-w-[300px] cursor-pointer overflow-hidden bg-white`,
  thumbnailWrapper: `relative overflow-hidden bg-gray-300`,
  descriptionSectionWrapper: (isDetailPage) => (isDetailPage ? `px-[16px] pt-[20px] pb-[16px]` : `pt-[16px]`),
  descriptionSection: `flex h-full flex-col`,
  descriptionCategoryWrapper: `Body2-14Md flex flex-row items-center gap-[4px] text-gray-700`,
  desciprtionTitle: `Title2-18Bd truncate-2-lines mt-[8px] max-h-[58px] min-h-[29px]`,
  desciprtionTagSection: `mt-[16px] flex flex-row gap-[8px]`,
  desciprtionTags: `Caption-12Bd flex rounded-[4px] bg-gray-100 px-[6px] pt-[2px] text-gray-600`,
  descriptionSubtitle: `truncate-2-lines keep-all Body2-14Md min-h-[42px] text-gray-700`,
}

export default EventCard

export const EventSkeletonCard = () => {
  return (
    <div className="flex flex-col sm:w-full lg:w-[336px]">
      <Skeleton.Rectangular w={'100%'} className="h-[189px] sm:h-[324px] md:h-[189px]" />
      <div className="mt-[16px] flex flex-row">
        <Skeleton.Rectangular w={40} h={23} />
        <Skeleton.Rectangular w={72} h={23} className="ml-[4px]" />
      </div>
      <Skeleton.Rectangular w={'100%'} h={24} className="mt-[16px]" />
      <Skeleton.Rectangular w={242} h={18} className="mt-[8px]" />
      <Skeleton.Rectangular w={242} h={18} className="mt-[8px]" />
    </div>
  )
}
